<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let activeArtboard = $state(undefined);
  onMount(() => {
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = aiBox.querySelectorAll('.g-artboard')[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-p10_traffic_minimap-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: lg -->
  {#if aiBoxWidth && aiBoxWidth >= 0}
    <div
      id="g-p10_traffic_minimap-lg"
      class="g-artboard"
      style="aspect-ratio: 1.19952596024705;"
      data-aspect-ratio="1.2"
      data-min-width="0"
    >
      <div
        id="g-p10_traffic_minimap-lg-img"
        class="g-p10_traffic_minimap-lg-img g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/p10_traffic_minimap-lg.jpg);"
      ></div>
      <div
        id="g-ai0-2"
        class="g-whiteshadow g-aiAbs g-aiPointText"
        style="top:17.7783%;margin-top:-9px;left:48.3812%;margin-left:-24.5px;width:49px;"
      >
        <p class="g-pstyle0">Iran</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-whiteshadow g-aiAbs g-aiPointText"
        style="top:54.1925%;margin-top:-9px;right:61.4919%;width:58px;"
      >
        <p class="g-pstyle1">Qatar</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-whiteshadow g-aiAbs g-aiPointText"
        style="top:64.0457%;margin-top:-9px;left:41.9763%;margin-left:-22px;width:44px;"
      >
        <p class="g-pstyle0">UAE</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-whiteshadow g-aiAbs g-aiPointText"
        style="top:67.8311%;margin-top:-17.7px;left:19.0156%;margin-left:-31.5px;width:63px;"
      >
        <p class="g-pstyle0">Saudi</p>
        <p class="g-pstyle0">Arabia</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-whiteshadow g-aiAbs g-aiPointText"
        style="top:71.1143%;margin-top:-9px;right:39.1692%;width:56px;"
      >
        <p class="g-pstyle1">Oman</p>
      </div>
      <div
        id="g-ai0-1"
        class="g-whiteshadow g-aiAbs g-aiPointText"
        style="top:7.2824%;margin-top:-9px;left:82.1636%;margin-left:-49.5px;width:99px;"
      >
        <p class="g-pstyle0">Afghanistan</p>
      </div>
    </div>
  {/if}
</div>

<!-- End ai2svelte - 2026-03-05 20:02 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-05 20:02 -->
<!-- ai file: p10_traffic_minimap.ai -->
<style lang="scss">
  #g-p10_traffic_minimap-box,
  #g-p10_traffic_minimap-box .g-artboard {
    margin: 0 auto;
  }
  #g-p10_traffic_minimap-box p {
    margin: 0;
  }
  #g-p10_traffic_minimap-box .g-aiAbs {
    position: absolute;
  }
  #g-p10_traffic_minimap-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p10_traffic_minimap-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-p10_traffic_minimap-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p10_traffic_minimap-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p10_traffic_minimap-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p10_traffic_minimap-lg .g-pstyle0 {
    font-weight: 400;
    height: 17px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-p10_traffic_minimap-lg .g-pstyle1 {
    font-weight: 400;
    height: 17px;
    text-align: right;
    text-transform: uppercase;
  }

  /* Custom CSS */
</style>
